import { render } from "./DashboardCampaignCard.vue?vue&type=template&id=408e621e"
import script from "./DashboardCampaignCard.vue?vue&type=script&lang=js"
export * from "./DashboardCampaignCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__